[...document.querySelectorAll('.appointment-button-wrapper')].forEach(wrapper => {
    const contactButton = wrapper.querySelector('.appointment-button--contact');
    const phoneButton = wrapper.querySelector('.appointment-button--phone');

    if (!contactButton.dataset.openingtimes || !phoneButton) return;

    const openingTimes = JSON.parse(contactButton.dataset.openingtimes);
    // e.g.
    // {1: "08:00-18:00", 2: "08:00-18:00", 3: "08:00-16:00,17:00-18:00", 4: "08:00-18:00", 5: "08:00-16:00"}

    // Now. TODO: Server/European time
    const today = new Date();
    const weekday = today.getDay();
    const hour = today.getHours();
    const minute = today.getMinutes();

    // Get relevant from-time and until-time
    const openingTimesToday = openingTimes[weekday];
    if (!openingTimesToday) return;
    const openingTimesTodayBeforeBreak = openingTimesToday.split(',')[0];
    const openingTimesTodayAfterBreak = openingTimesToday.split(',')[1];

    // Check if it's open
    if (
        currentlyBetweenTime(hour, minute, openingTimesTodayBeforeBreak) ||
        currentlyBetweenTime(hour, minute, openingTimesTodayAfterBreak)
    ) {
        contactButton.style.display = 'none';
        phoneButton.style.display = 'inline-block';
    }
});

function currentlyBetweenTime(hour, minute, openingTimes) {
    if (!openingTimes) return false;

    const openFrom = openingTimes.split('-')[0];
    const openUntil = openingTimes.split('-')[1];
    const openFromHour = parseInt(openFrom.split(':')[0]);
    const openFromMinute = parseInt(openFrom.split(':')[1]);
    const openUntilHour = parseInt(openUntil.split(':')[0]);
    const openUntilMinute = parseInt(openUntil.split(':')[1]);

    const isAfterStart = hour > openFromHour || (hour == openFromHour && minute >= openFromMinute);
    const isBeforeEnd = hour < openUntilHour || (hour == openUntilHour && minute <= openUntilMinute);

    return isAfterStart && isBeforeEnd;
}

[...document.querySelectorAll('.appointment-button--show')].forEach(btn => {
    btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
        btn.parentElement.nextSibling.style.display = 'block';
    });
});
